import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function TestCompletePage({ mode }) {
  const navigate = useNavigate();
  useEffect(() => {
    const completedKey =
      mode === 'sound'
        ? 'emotionSurveySoundTestCompleted'
        : 'emotionSurveySilentTestCompleted';
    localStorage.setItem(completedKey, 'true');
    localStorage.removeItem('emotionSurveyCurrentTestMode');

    const timeoutId = setTimeout(() => {
      navigate('/all-tests-complete', { replace: true });
    }, 500);

    return () => clearTimeout(timeoutId);
  }, [mode, navigate]);

  const handleImmediateRedirect = () => {
    navigate('/all-tests-complete', { replace: true });
  };

  return (
    <div className="page-container">
      <h2>Вы завершили тест {mode === 'sound' ? 'со звуком' : 'без звука'}!</h2>
	  <p>Переходим к финальной странице исследования...</p>
      <div className="navigation-buttons">
		<button onClick={handleImmediateRedirect}>Перейти сейчас</button>
      </div>
    </div>
  );
}

export default TestCompletePage;